import { z } from 'zod'

const REQUIRED_FIELD = 'validations.requiredField'
const INVALID_EMAIL = 'validations.invalidEmail'

export const required = z.string({ error: REQUIRED_FIELD }).refine((value) => value.trim().length > 0, REQUIRED_FIELD)
export const optional = z.string().optional()
export const requiredEmail = z.string({ error: REQUIRED_FIELD }).min(1, REQUIRED_FIELD).email(INVALID_EMAIL)
